export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface ComicData {
  id: string;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  tags: string[];
  coverImage: string;
  description: string;
  rating: number;
  views: number;
  favorites: number;
  status: '连载中' | '已完结';
  updatedAt: string;
  createdAt: string;
  chapters: ComicChapter[];
}

export const comics: ComicData[] = [
  {
    id: 'comic-1',
    title: '甜蜜陷阱',
    author: '金智恩',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '校园', '甜宠'],
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20manhwa%20style%20cover%20art%2C%20a%20sweet%20young%20couple%20in%20school%20uniforms%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20peach%20color%20palette%2C%20watercolor%20illustration%2C%20romantic%20and%20dreamy%20atmosphere%2C%20anime%20style%20with%20delicate%20linework%2C%20warm%20spring%20lighting&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '高中生林小桃意外发现校草学长的秘密，一段甜蜜又心动的校园恋爱故事就此展开。可爱活泼的女主角和冷酷温柔的男主角，带来让人心跳加速的浪漫剧情。',
    rating: 4.8,
    views: 1285000,
    favorites: 89200,
    status: '连载中',
    updatedAt: '2026-08-05',
    createdAt: '2025-03-15',
    chapters: [
      { id: 'ch-1-1', title: '第1话 意外的相遇', number: 1, updatedAt: '2025-03-15' },
      { id: 'ch-1-2', title: '第2话 秘密被发现了', number: 2, updatedAt: '2025-03-22' },
      { id: 'ch-1-3', title: '第3话 心跳加速', number: 3, updatedAt: '2025-03-29' },
      { id: 'ch-1-45', title: '第45话 心动的告白', number: 45, updatedAt: '2026-08-05' },
    ],
  },
  {
    id: 'comic-2',
    title: '魔法少女的日常',
    author: '李美娜',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['奇幻', '魔法', '日常'],
    coverImage: 'https://readdy.ai/api/search-image?query=Adorable%20Korean%20manhwa%20style%20cover%2C%20a%20magical%20girl%20with%20colorful%20sparkles%20and%20a%20cute%20familiar%20cat%2C%20pastel%20pink%20and%20lavender%20color%20scheme%2C%20whimsical%20fantasy%20illustration%2C%20soft%20watercolor%20texture%2C%20dreamy%20magical%20atmosphere&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '普通女高中生意外获得了魔法力量，从此过上了双重生活。白天是普通学生，晚上变身魔法少女保护城市。可爱又热血的魔法冒险故事！',
    rating: 4.7,
    views: 956000,
    favorites: 67300,
    status: '连载中',
    updatedAt: '2026-08-04',
    createdAt: '2025-06-01',
    chapters: [
      { id: 'ch-2-1', title: '第1话 魔法的觉醒', number: 1, updatedAt: '2025-06-01' },
      { id: 'ch-2-2', title: '第2话 第一次变身', number: 2, updatedAt: '2025-06-08' },
      { id: 'ch-2-38', title: '第38话 新的敌人', number: 38, updatedAt: '2026-08-04' },
    ],
  },
  {
    id: 'comic-3',
    title: '猫咪咖啡厅',
    author: '朴智秀',
    category: '日常',
    categorySlug: 'daily',
    tags: ['日常', '治愈', '猫咪'],
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20manhwa%20cover%20art%2C%20a%20cozy%20cat%20cafe%20interior%20with%20adorable%20fluffy%20cats%20and%20a%20gentle%20female%20protagonist%2C%20warm%20beige%20and%20cream%20color%20palette%2C%20healing%20and%20relaxing%20atmosphere%2C%20soft%20illustration%20style&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '在城市的一角有一家神奇的猫咪咖啡厅，每只猫咪都有独特的故事。来这里喝杯咖啡，听听猫咪们的小秘密，温暖治愈你的每一天。',
    rating: 4.9,
    views: 1520000,
    favorites: 105400,
    status: '连载中',
    updatedAt: '2026-08-05',
    createdAt: '2024-11-20',
    chapters: [
      { id: 'ch-3-1', title: '第1话 欢迎光临', number: 1, updatedAt: '2024-11-20' },
      { id: 'ch-3-52', title: '第52话 新来的小橘猫', number: 52, updatedAt: '2026-08-05' },
    ],
  },
  {
    id: 'comic-4',
    title: '星之彼方',
    author: '尹银河',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['奇幻', '冒险', '星空'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%2C%20a%20girl%20and%20boy%20traveling%20through%20starry%20skies%20on%20a%20magical%20boat%2C%20dreamy%20night%20sky%20with%20twinkling%20stars%2C%20soft%20blue%20and%20warm%20pink%20gradient%2C%20enchanting%20illustration&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '两个来自不同世界的少年少女，在星空下相遇。为了找到回家的路，他们踏上了跨越星海的奇妙冒险之旅。',
    rating: 4.6,
    views: 789000,
    favorites: 54200,
    status: '已完结',
    updatedAt: '2026-06-30',
    createdAt: '2024-08-10',
    chapters: [
      { id: 'ch-4-1', title: '第1话 星空下的约定', number: 1, updatedAt: '2024-08-10' },
      { id: 'ch-4-60', title: '第60话 最终章 回到你身边', number: 60, updatedAt: '2026-06-30' },
    ],
  },
  {
    id: 'comic-5',
    title: '面包店的小确幸',
    author: '崔多仁',
    category: '日常',
    categorySlug: 'daily',
    tags: ['日常', '美食', '治愈'],
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20manhwa%20style%20cover%2C%20a%20warm%20bakery%20shop%20with%20delicious%20pastries%20and%20a%20smiling%20female%20baker%2C%20golden%20warm%20lighting%2C%20cozy%20and%20inviting%20atmosphere%2C%20food%20illustration%20with%20soft%20textures&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '辞去大公司工作后，女主角开了一间小小的面包店。每天烤面包、与客人分享温暖故事，平凡的日子里藏着最真实的小确幸。',
    rating: 4.8,
    views: 1100000,
    favorites: 78100,
    status: '连载中',
    updatedAt: '2026-08-03',
    createdAt: '2025-01-05',
    chapters: [
      { id: 'ch-5-1', title: '第1话 重新开始', number: 1, updatedAt: '2025-01-05' },
      { id: 'ch-5-32', title: '第32话 特别的订单', number: 32, updatedAt: '2026-08-03' },
    ],
  },
  {
    id: 'comic-6',
    title: '恋爱笔记本',
    author: '韩素熙',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '办公室', '甜宠'],
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20manhwa%20cover%2C%20a%20handsome%20male%20lead%20and%20cute%20female%20lead%20in%20office%20attire%20sharing%20a%20sweet%20moment%2C%20soft%20pink%20and%20cream%20color%20scheme%2C%20modern%20romance%20illustration%20with%20delicate%20details&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '职场新人安多晴的恋爱笔记本上，写满了对部门经理的小心思。当这本笔记本不小心被经理看到，一段办公室暗恋开始变得不再平静。',
    rating: 4.7,
    views: 1340000,
    favorites: 93200,
    status: '连载中',
    updatedAt: '2026-08-04',
    createdAt: '2025-04-20',
    chapters: [
      { id: 'ch-6-1', title: '第1话 第一天上班', number: 1, updatedAt: '2025-04-20' },
      { id: 'ch-6-40', title: '第40话 笔记本的秘密', number: 40, updatedAt: '2026-08-04' },
    ],
  },
  {
    id: 'comic-7',
    title: '精灵森林日记',
    author: '赵敏雅',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['奇幻', '精灵', '自然'],
    coverImage: 'https://readdy.ai/api/search-image?query=Enchanting%20Korean%20manhwa%20style%20cover%2C%20tiny%20cute%20fairies%20living%20in%20a%20magical%20forest%20with%20glowing%20mushrooms%20and%20flowers%2C%20soft%20green%20and%20warm%20golden%20light%2C%20whimsical%20fantasy%20nature%20illustration&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '搬到乡下外婆家的小女孩，在后山的森林里发现了精灵的世界。每天和精灵朋友们一起探索自然，记录下美好的森林日记。',
    rating: 4.9,
    views: 1670000,
    favorites: 115800,
    status: '连载中',
    updatedAt: '2026-08-05',
    createdAt: '2024-06-15',
    chapters: [
      { id: 'ch-7-1', title: '第1话 森林的入口', number: 1, updatedAt: '2024-06-15' },
      { id: 'ch-7-72', title: '第72话 精灵的节日', number: 72, updatedAt: '2026-08-05' },
    ],
  },
  {
    id: 'comic-8',
    title: '花店物语',
    author: '孙艺琳',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '花店', '温情'],
    coverImage: 'https://readdy.ai/api/search-image?query=Soft%20Korean%20manhwa%20cover%20art%2C%20a%20beautiful%20flower%20shop%20filled%20with%20colorful%20blooms%20and%20a%20gentle%20female%20florist%2C%20romantic%20spring%20atmosphere%2C%20pastel%20pink%20and%20green%20color%20palette%2C%20delicate%20illustration&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '继承外婆花店的年轻女孩，用每一束花传递着客人们的心意。在花香的氤氲中，她自己也遇到了意想不到的缘分。',
    rating: 4.5,
    views: 678000,
    favorites: 45100,
    status: '已完结',
    updatedAt: '2026-05-15',
    createdAt: '2024-12-01',
    chapters: [
      { id: 'ch-8-1', title: '第1话 花店的新主人', number: 1, updatedAt: '2024-12-01' },
      { id: 'ch-8-48', title: '第48话 最终话 花开时节', number: 48, updatedAt: '2026-05-15' },
    ],
  },
  {
    id: 'comic-9',
    title: '萌宠医院',
    author: '张美英',
    category: '日常',
    categorySlug: 'daily',
    tags: ['日常', '宠物', '治愈'],
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20manhwa%20style%20cover%2C%20a%20veterinary%20clinic%20with%20adorable%20puppies%20and%20kittens%20and%20a%20kind%20female%20veterinarian%2C%20warm%20and%20healing%20atmosphere%2C%20soft%20pastel%20colors%2C%20heartwarming%20illustration&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '动物医院里每天上演着萌宠和主人之间的感人故事。年轻的兽医和可爱的动物们，带来最治愈的日常喜剧。',
    rating: 4.8,
    views: 945000,
    favorites: 67200,
    status: '连载中',
    updatedAt: '2026-08-02',
    createdAt: '2025-02-14',
    chapters: [
      { id: 'ch-9-1', title: '第1话 第一位患者', number: 1, updatedAt: '2025-02-14' },
      { id: 'ch-9-35', title: '第35话 流浪猫救助', number: 35, updatedAt: '2026-08-02' },
    ],
  },
  {
    id: 'comic-10',
    title: '甜点师与咖啡',
    author: '金多美',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '美食', '甜宠'],
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20manhwa%20cover%2C%20a%20handsome%20pastry%20chef%20and%20a%20cute%20barista%20girl%20in%20a%20cozy%20dessert%20shop%2C%20sweet%20desserts%20and%20coffee%20art%2C%20warm%20caramel%20and%20cream%20tones%2C%20delicious%20and%20romantic%20illustration&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '甜点师和咖啡师的浪漫邂逅，一个是甜点界的天才，一个是热爱咖啡的女孩。在甜品和咖啡的香气中，两颗心慢慢靠近。',
    rating: 4.6,
    views: 890000,
    favorites: 61200,
    status: '连载中',
    updatedAt: '2026-08-01',
    createdAt: '2025-05-10',
    chapters: [
      { id: 'ch-10-1', title: '第1话 新来的咖啡师', number: 1, updatedAt: '2025-05-10' },
      { id: 'ch-10-28', title: '第28话 特别的甜品', number: 28, updatedAt: '2026-08-01' },
    ],
  },
  {
    id: 'comic-11',
    title: '时间邮局',
    author: '郑素拉',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['奇幻', '时间', '温情'],
    coverImage: 'https://readdy.ai/api/search-image?query=Magical%20Korean%20manhwa%20cover%2C%20a%20mysterious%20old%20post%20office%20with%20glowing%20letters%20floating%20in%20air%2C%20a%20young%20postwoman%20in%20vintage%20uniform%2C%20warm%20sepia%20and%20golden%20tones%2C%20nostalgic%20and%20magical%20atmosphere&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '在小镇角落有一家特殊的邮局，可以寄信给过去或未来的自己。每一封信都承载着一段动人的故事和未说出口的心情。',
    rating: 4.9,
    views: 1450000,
    favorites: 98700,
    status: '连载中',
    updatedAt: '2026-08-05',
    createdAt: '2024-09-01',
    chapters: [
      { id: 'ch-11-1', title: '第1话 第一封信', number: 1, updatedAt: '2024-09-01' },
      { id: 'ch-11-55', title: '第55话 十年后的回信', number: 55, updatedAt: '2026-08-05' },
    ],
  },
  {
    id: 'comic-12',
    title: '小熊软糖',
    author: '刘彩英',
    category: '日常',
    categorySlug: 'daily',
    tags: ['日常', '校园', '温馨'],
    coverImage: 'https://readdy.ai/api/search-image?query=Adorable%20Korean%20manhwa%20cover%2C%20two%20cute%20elementary%20school%20friends%20sharing%20gummy%20bears%20in%20a%20sunny%20classroom%2C%20childlike%20and%20innocent%20atmosphere%2C%20soft%20pastel%20yellow%20and%20pink%2C%20heartwarming%20illustration&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '小学二年级的双胞胎兄妹和他们的小伙伴们，每一天都像小熊软糖一样QQ弹弹、甜甜蜜蜜。最纯真的童年故事，让人忍不住微笑。',
    rating: 4.8,
    views: 2100000,
    favorites: 143200,
    status: '连载中',
    updatedAt: '2026-08-04',
    createdAt: '2023-03-01',
    chapters: [
      { id: 'ch-12-1', title: '第1话 开学第一天', number: 1, updatedAt: '2023-03-01' },
      { id: 'ch-12-180', title: '第180话 运动会', number: 180, updatedAt: '2026-08-04' },
    ],
  },
];

export const popularComics = comics
  .sort((a, b) => b.views - a.views)
  .slice(0, 6);

export const latestComics = comics
  .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
  .slice(0, 6);

export const completedComics = comics.filter(c => c.status === '已完结');

export function getComicById(id: string): ComicData | undefined {
  return comics.find(c => c.id === id);
}

export function getComicsByCategory(slug: string): ComicData[] {
  return comics.filter(c => c.categorySlug === slug);
}